import React from 'react';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import Error from 'shared-vectors/icons/Error';
import { Icon } from 'shared-vectors';
import InputField from '../InputField';

import styles, { mainCls } from './styles';

const useStyles = createStyle(styles);

export default function UserInput({
  type,
  name,
  value,
  placeholder,
  error,
  errorMsg,
  fieldDesc,
  className,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  pattern,
  autoComplete = null,
  autocorrect = null,
  iconCloseAdditionAction = null,
  disabled = false,
  inputId = null,
}) {
  const cls = useStyles();
  
  const ctnClsName = makeClassName([
    cls[`${mainCls}`],
    className,
  ]);

  const errMsgClsName = makeClassName([
    cls[`${mainCls}__errorMsg`],
    'mt--xs',
    'tp-s--xs',
    'tp-w--m',
    'tp-a--l',
    'c-txt--err',
  ]);

  const fieldDescClsName = makeClassName([
    cls[`${mainCls}__fieldDesc`],
    'mt--xs',
    'tp-s--xs',
    'tp-w--m',
    'tp-a--l',
    'c-txt--f2',
  ]);  

  const synch = (x) => onChange(name, x);

  return (
    <div className={ctnClsName}>
      <div className={cls[`${mainCls}__ctn`]}>
        <InputField
          disabled={disabled}
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          className={error ? 'c-br--err' : ''}
          onChange={synch}
          onBlur={onBlur}
          onFocus={onFocus}
          iconClose={type !== 'password'}
          pattern={pattern}
          onKeyDown={onKeyDown || null}
          autoComplete={autoComplete}
          iconCloseAdditionAction={iconCloseAdditionAction}
          autocorrect={autocorrect}
          inputId={inputId}
        />
      </div>
      {
        error
        && errorMsg
        && (
          <p className={errMsgClsName}>
            <Icon width="14px" name={Error} fill />{errorMsg}
          </p>
        )
      }
      {
        fieldDesc
        && (
          <p className={fieldDescClsName}>
            {fieldDesc}
          </p>
        )
      }      
    </div>
  );
}